export default ({ Factory }) => ({

  /**
   * Получение пользователя
   * @param {String} id - идентификатор пользователя
   */
  get: (id) => Factory[id].get(),

  /**
   * Редактирование пользователя
   * @param {Object} user - Пользователь
   */
  edit: (user) => Factory.post(user),

  /**
   * Получение текущего пользователя
   */
  current: () => Factory.get(),

  /**
   * Получение списка пользователей
   */
  list: () => Factory.list.get(),

  /**
   * Удаление пользователя
   * @param {Number} id - идентификатор пользователя
   */
  remove: (id) => Factory[id].delete(),
})